import { decodeHtmlEntities } from "~/helpers/decodeHtmlEntities";

// Mirrors wsapi's agGridRows searchText normalization (entity decode, trademark strip, NFKC, whitespace collapse).
const TRADEMARK_MARKS = /[™®]/g;
const UNICODE_WHITESPACE_RUN = /[\s   -   　﻿]+/g;

const normalizeSearchText = (value: string): string =>
	decodeHtmlEntities(value).replace(TRADEMARK_MARKS, "").normalize("NFKC").replace(UNICODE_WHITESPACE_RUN, " ").trim();

export default normalizeSearchText;
